(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rhino-bogo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rhino-bogo')) {
  customElements.define('rhino-bogo', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.images = JSON.parse(this.querySelector('[data-bundle-images]').textContent);
      this.tiers = [...this.querySelectorAll('details')];
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency});
      this.tiers.forEach(tier => {
        tier.querySelector('summary').addEventListener('click',event => {
          event.preventDefault();
          this.tiers.forEach(other => { other.open = other === tier; });
          this.update(tier,true);
        });
        tier.addEventListener('change',()=>this.update(tier,true));
        tier.querySelector('form').addEventListener('submit',event=>this.add(event,tier));
        this.update(tier,false);
      });
      customElements.whenDefined('media-gallery').then(()=>this.update(this.tiers[0],true));
    }
    update(tier, gallery) {
      const count = Number(tier.dataset.tier);
      const salves = [...tier.querySelectorAll('select')].filter(select=>select.value===this.dataset.salveId).length;
      const rhinos = count*2-salves;
      const image = this.images[`${rhinos}r${salves}s`];
      if(image?.url) {
        const thumb=tier.querySelector('img');
        thumb.removeAttribute('srcset');thumb.src=image.url;thumb.alt=image.alt;
        tier.querySelector('[data-count]').textContent=image.alt;
        if(gallery && image.media) {
          const element=document.getElementById(`MediaGallery-${this.dataset.section}`) || document.querySelector('media-gallery');
          element?.setActiveMedia?.(`${this.dataset.section}-${image.media}`,false);
        }
      }
      tier.querySelector('[data-value]').textContent=this.money.format((rhinos*Number(this.dataset.rhinoPrice)+salves*Number(this.dataset.salvePrice))/100);
    }
    async add(event,tier) {
      event.preventDefault();
      if(this.busy) return;
      this.busy=true;
      const button=tier.querySelector('button[type=submit]');const label=button.textContent;
      const error=tier.querySelector('[role=alert]');error.hidden=true;
      button.disabled=true;button.textContent=this.dataset.loading;
      try {
        const quantities=new Map([[this.dataset.rhinoId,Number(tier.dataset.tier)]]);
        tier.querySelectorAll('select').forEach(select=>quantities.set(select.value,(quantities.get(select.value)||0)+1));
        const root=window.Shopify?.routes?.root || '/';
        const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[...quantities].map(([id,quantity])=>({id,quantity}))})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description || this.dataset.error);
        window.location.assign(`${root}cart`);
      } catch(problem) {
        error.textContent=problem.message || this.dataset.error;error.hidden=false;
        button.disabled=false;button.textContent=label;this.busy=false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
